import { MutationTree } from 'vuex'
import { SchemeState } from './state'

export enum SchemeMutation {
  SetBackgrounded = 'SetBackgrounded',
}

export const mutations: MutationTree<SchemeState> = {
  [SchemeMutation.SetBackgrounded](state, payload: boolean) {
    state.isBackgrounded = payload
  },
}
